
import { MHTTPCL, JSON_STRING } from "../../../services/http/http-client";
import { LABEL_URL, BELIEVE_CONTROLLER_URL, CONTACTS_URL, MODIFICATION_URL, DISTRIBUTION_URL, SETTINGS_URL } from "../../../services/common-urls";
export const AccountsService = {
    getAccounts: ({
        start = 0
    }) => MHTTPCL.post(LABEL_URL, {
        section: 'royalty',
        action: 'search_royalty_account',
        limit_start: start,
        limit_end: 50

    }),
    getNewRoyaltyAccountData: () => MHTTPCL.post(LABEL_URL, {
        section: 'royalty',
        action: 'get_new_royalty_account_data',
    }),
    RPpaymentinfomodaldata: (royalty_account_id) => MHTTPCL.post(LABEL_URL, {
        section: 'royalty',
        action: 'rp_payment_info_modal_data',
        royalty_account_id:royalty_account_id
    }),
    saveRPpaymentdata: (data) => MHTTPCL.post(LABEL_URL, {
        section: 'royalty',
        action: 'save_rp_payment_info',
        json_data: data?.rpModelData ? JSON.stringify(data?.rpModelData) : null,
        royalty_period_id:data.royalty_period_id
    }),

    saveRoyaltyAccount: ({ royalty_account_name, royalty_period, invoice_project_id, payment_yes_no }) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "royalty_account_form_data",
        royalty_account_name,
        royalty_period,
        invoice_project_id,
        payment_yes_no,
        output: JSON_STRING
    }),

    advancedSearch: () => MHTTPCL.get(LABEL_URL, {
        section: 'royalty',
        action: 'royalty_account_advance_search',
        output: JSON_STRING,
    }),
    searchAccounts: (search,start) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "search_royalty_account",
        search_str: search,
        output: JSON_STRING,
        limit_start: start,
        limit_end: 50
    }),
    searchExternalUsers: (royalty_account_id, search = null) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "external_user_relation_widget_data",
        search_term: search,
        external_id: royalty_account_id,
        external_table: 'royalty_statement',
        output: JSON_STRING
    }),


    addExternalUser: (royalty_account_id, external_user_ids) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "make_ext_user_relation",
        external_id: royalty_account_id,
        external_user_ids: external_user_ids,
        external_table: 'royalty_statement',
        module: 'royalty_account',
        output: JSON_STRING
    }),
    deleteExternalUser: (external_user_id) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "delete_ext_user_relation",
        external_users_permission_id: external_user_id,
        output: JSON_STRING
    }),
    getFirstLoginExternalUser: (external_user_id) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "get_first_login_ext_user",
        external_user_id: external_user_id,
        output: JSON_STRING
    }),
    
   shareInvitationEmailData: (external_user_id,invoice_project_id) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "share_invitation_email_data",
        external_user_id: external_user_id,
        invoice_project_id:invoice_project_id,
        output: JSON_STRING
    }),
    checkUniquenessOfExternalUser: (user_name) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "is_unique_ext_user_name",
        user_name: user_name,
        output: JSON_STRING
    }),
    checkUniquenessOfExternalUserEmail: (email) => MHTTPCL.get(SETTINGS_URL, {
        section: "ext_user_setup",
        action: "is_email_taken",
        email: email,
        output: JSON_STRING
    }),
    newExternalUser: ({ user_name, given_name, email }) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "add_ext_user",
        user_name,
        given_name,
        email,
        output: JSON_STRING
    }),

    fetchAdvancedSearch: ({
        search_str = '',
        statement_type = '',
        royalty_period = '',
        label_status_id = 0,
        sage_id_str = '',
        royalty_account_name = '',
        currency = '',
        company_id = '',
        invoice_project_id = '',
        payment_yes_no = '',
        vat_type = '',
        tax_type_id = '',
        country_fullname = '',
        offset = 0
    } = {}) => {
        return MHTTPCL.post(LABEL_URL, {
            search_str,
            statement_type,
            royalty_period,
            label_status_id,
            sage_id_str,
            royalty_account_name,
            currency,
            company_id,
            invoice_project_id,
            payment_yes_no,
            vat_type,
            tax_type_id,
            country_fullname,
            section: "royalty",
            action: "search_royalty_account",
            offset
        })
    },

    removeAccounts: (royalty_account_id) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "delete_royalty_account",
        royalty_account_id: royalty_account_id
    }),

    get_royalty_account_setup: royalty_account_id =>
        MHTTPCL.get(LABEL_URL, {
            section: "royalty",
            action: "get_royalty_account_setup",
            royalty_account_id,
            output: JSON_STRING
        }),
    fetchRoyaltyExternalUsers: royalty_account_id =>
        MHTTPCL.get(LABEL_URL, {
            section: "royalty",
            action: "get_related_ext_users",
            external_id: royalty_account_id,
            external_table: 'royalty_statement',
            output: JSON_STRING
        }),
        get_royalty_account_contracts: royalty_account_id =>
        MHTTPCL.post(LABEL_URL, {
            section: "royalty",
            action: "get_royalty_account_contracts",
            royalty_account_id
        }),
        royalty_account_balances: (royalty_account_id,start=0,row_count=100) =>
        MHTTPCL.post(LABEL_URL, {
            section: "royalty",
            action: "royalty_account_balances",
            royalty_account_id,
            start,
            row_count
        }),
    get_royalty_account_statements: royalty_account_id =>
        MHTTPCL.get(LABEL_URL, {
            section: "royalty",
            action: "get_royalty_account_statements",
            royalty_account_id
        }).then(res=>{
            return{
                ...res,
                data:{
                    //TODO: Remove this statement_data from here. It is not needed. -Noman
                    statement_data:res.data.royalty_periods,    // Dont thing this is needed. Where is it needed ? -Noman
                    royalty_periods:res.data.royalty_periods
                }
            }
        }),
    updateB2BData: royalty_account_id =>
        MHTTPCL.get(LABEL_URL, {
            section: "royalty",
            action: "update_b2b_data",
            royalty_account_id
        }),
    deleteContactRelation: (contact_relation_id) => MHTTPCL.post(CONTACTS_URL, {
        action: "delete_relation",
        contact_relation_id: contact_relation_id
    }),
    exportRoyaltyBalaces: (royalty_account_id) => MHTTPCL.getFinalURL(LABEL_URL, {
        section: "royalty",
        action: "export_royalty_balances",
        royalty_account_id: royalty_account_id,
        output: JSON_STRING
    }),
    addRoyaltyAccountMainContact: ({ royalty_account_id, contact_id }) => MHTTPCL.post(CONTACTS_URL, {
        action: 'set_item_contact',
        table: 'l_royalty_accounts',
        key: 'royalty_account_id',
        kVal: royalty_account_id,
        name: 'contact_id',
        value: contact_id,
        output: JSON_STRING
    }),
    modifyPayment: ({ payment_id, payment_date, matching_date, payment_amount }) => MHTTPCL.post(MODIFICATION_URL, {
        modify_type: 'record',
        table: 'payments',
        kVal: payment_id,
        payment_date,
        matching_date,
        payment_amount,
        output: JSON_STRING
    }),
    undoPayment: ({ payment_id }) => MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
        action: 'statement_payments_tab_undo_payment',
        payment_id: payment_id,
        output: JSON_STRING
    }),

    modify: ({ table, kVal, name, value }) => MHTTPCL.post(MODIFICATION_URL, {
        table,
        kVal,
        name,
        value,
        output: JSON_STRING
    }),
    modifyJSON: ({ table, kVal, name, value }) => MHTTPCL.post(MODIFICATION_URL, {
        kVal,
        name,
        value,
        table,
        modify_type: '',
        json_op: '',
        json_key: '',
        output: JSON_STRING,
        
    }),

    fetchStatementFormData: (royalty_account_id) => MHTTPCL.post(LABEL_URL, {
        section: 'royalty',
        action: 'statement_form_data',
        royalty_account_id: royalty_account_id,
        output: JSON_STRING
    }),


    countRp: ({ royalty_account_id, start_date, end_date }) => MHTTPCL.post2(LABEL_URL, {
        section: 'royalty',
        action: 'count_rp',
        royalty_account_id,
        start: start_date,
        end: end_date,
        output: JSON_STRING
    }),
    checkStatementDate: ({ start_date, end_date }) => MHTTPCL.post2(LABEL_URL, {
        section: 'royalty',
        action: 'check_royalty_dates',
        start_date,
        end_date,
        output: JSON_STRING
    }),
    createStatement: ({ royalty_account_id, start_date, end_date }) => MHTTPCL.post(LABEL_URL, {
        section: 'royalty',
        action: 'create_statement',
        royalty_account_id,
        start_date,
        end_date,
        output: JSON_STRING
    }, {
        subdomain: 'batch'
    }),

    addNewRoyaltyAccountBalance: (royalty_account_id) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "add_new_ra_balance",
        royalty_account_id: royalty_account_id,
        output: JSON_STRING
    }),
    balanceAdvanceSearch: ({
        royalty_account_id = 0,
        str = "",
        account = "",
        balance_type = "",
    }) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "balance_advance_search",
        royalty_account_id,
        str,
        account,
        balance_type,
        output: JSON_STRING
    }),
    balanceAdvanceSearchWithoutString: ({
        royalty_account_id = 0,
        account = "",
        balance_type = "",
        amount_end = "",
        start_date = "",
        end_date = "",
        period = "",
        contract = "",
        description = "",
        amount_start = "" }) => MHTTPCL.post(LABEL_URL, {
            section: "royalty",
            action: "balance_advance_search",
            royalty_account_id,
            account,
            balance_type,
            amount_end,
            start_date,
            end_date,
            period,
            contract,
            description,
            amount_start,
            output: JSON_STRING
        }),
    fetchStatementPaymentsTab: ({ royalty_account_id = 0, search_str = "", search_status = "" } = {}) => MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
        action: "statement_payments_tab",
        royalty_account_id,
        search_str,
        search_status,
        output: JSON_STRING
    }),



    fetchNewContractFormData: () => MHTTPCL.post(LABEL_URL, {
        action: "new_contract_form_data",
        section: 'royalty',
        output: JSON_STRING
    }),
    fetchAllRoyaltyAccounts: () => MHTTPCL.post(LABEL_URL, {
        action: "all_royalty_accounts",
        section: 'royalty',
        output: JSON_STRING
    }),
    copyContract: ({ royalty_account_id, contract_id }) => MHTTPCL.post(LABEL_URL, {
        action: "copy_contract",
        section: 'royalty',
        contract_id,
        royalty_account_id,
        output: JSON_STRING
    }),

    fetchRoyaltyAccountContracts: ({ royalty_account_id = 0 } = {}) => MHTTPCL.post(LABEL_URL, {
        action: "get_royalty_account_contracts",
        section: 'royalty',
        royalty_account_id,
        output: JSON_STRING
    }),

    addNewContractFromTemplate: ({ contract_name = ""
        , royalty_account_id = 0
        , contract_id = ""
        , } = {}) => MHTTPCL.post(LABEL_URL, {
            action: "new_contract_from_template",
            section: 'royalty',
            contract_name,
            royalty_account_id,
            contract_id,

            output: JSON_STRING
        }),
    addNewContract: ({ contract_name = ""
        , royalty_account_id = 0
        , physical_royalty_rate = ""
        , digital_royalty_rate = ""
        , license_royalty_rate = ""
        , cost_split_percent = ""
        , fix_price = ""
        , digital_base = ""
        , physical_base = "" } = {}) => MHTTPCL.post(LABEL_URL, {
            action: "new_contract",
            section: 'royalty',
            contract_name,
            royalty_account_id,
            physical_royalty_rate,
            digital_royalty_rate,
            license_royalty_rate,
            fix_price,
            physical_base,
            digital_base,
            cost_split_percent,
            output: JSON_STRING
        }),
    addNewMechanicalContract: ({
        contract_name = "",
        territory_id = '',
        phy_mechanical_rate_id = '',
        phy_exclude = "",
        bundle_dl_mechanical_rate_id = "",
        bundle_dl_exclude = "",
        track_dl_mechanical_rate_id = "",
        track_dl_exclude = "",
        royalty_account_id = "",
        physical_royalty_rate = "",
        digital_royalty_rate = "",
        license_royalty_rate = "",
        fix_price = "",
        physical_base = "",
        digital_base = "",
        cost_split_percent = "", } = {}) => MHTTPCL.post(LABEL_URL, {
            section: "royalty",
            action: "new_mechanical_contract",
            contract_name,
            territory_id,
            phy_mechanical_rate_id,
            phy_exclude,
            bundle_dl_mechanical_rate_id,
            bundle_dl_exclude,
            track_dl_mechanical_rate_id,
            track_dl_exclude,
            royalty_account_id,
            physical_royalty_rate,
            digital_royalty_rate,
            license_royalty_rate,
            fix_price,
            physical_base,
            digital_base,
            cost_split_percent,
            output: JSON_STRING
        }),
    fetchMechanicalContractFormData: ({ contract_name = ""
        , royalty_account_id = 0
        , physical_royalty_rate = ""
        , digital_royalty_rate = ""
        , license_royalty_rate = ""
        , cost_split_percent = ""
        , fix_price = ""
        , digital_base = ""
        , physical_base = "" } = {}) => MHTTPCL.post(LABEL_URL, {
            action: "mechanical_contract_modal",
            section: 'royalty',
            contract_name,
            royalty_account_id,
            physical_royalty_rate,
            digital_royalty_rate,
            license_royalty_rate,
            fix_price,
            physical_base,
            digital_base,
            cost_split_percent,
            output: JSON_STRING
        }),

    deleteBalance: ({ balance_id = 0 } = {}) => MHTTPCL.post(LABEL_URL, {
        action: "delete_balance",
        section: 'royalty',
        balance_id,
        output: JSON_STRING
    }),
    removeRoyaltyPeriod: ({ royalty_period_id = 0, royalty_period_bundle_id } = {}) => MHTTPCL.post(LABEL_URL, {
        action: "remove_royalty_period",
        section: 'royalty',
        royalty_period_id,
        royalty_period_bundle_id,
        output: JSON_STRING
    }),
    // countRoyaltyPeriodPayment: ({ royalty_period_id = 0, royalty_period_bundle_id } = {}) => MHTTPCL.post(LABEL_URL, {
    //     action: "count_royalty_period_payment",
    //     section: 'royalty',
    //     royalty_period_id,
    //     royalty_period_bundle_id,
    //     output: JSON_STRING
    // }),
    // royaltyPeriodInvoiceInfo: ({ royalty_period_id = 0, royalty_period_bundle_id } = {}) => MHTTPCL.post(LABEL_URL, {
    //     action: "royalty_period_invoice_info",
    //     section: 'royalty',
    //     royalty_period_id,
    //     royalty_period_bundle_id,
    //     output: JSON_STRING
    // }),
    royaltyContractReport: ({ royalty_account_id = 0 } = {}) => MHTTPCL.post(DISTRIBUTION_URL, {
        action: "view_order_proforma_invoice_select_template",
        section: 'orders',
        template_section: 'royalty_account',
        section_name: 'royalty',
        controller_name: 'label.pl',
        action_name: 'royalty_contract_report',
        identifier: 'royalty_account_id',
        id: royalty_account_id,
        output: JSON_STRING
    }),
    checkingOnDeleteRoyaltyAccount: (royalty_account_id) => MHTTPCL.post(LABEL_URL, {
        action: "checking_on_delete_royalty_account",
        section: 'royalty',
        royalty_account_id: royalty_account_id,
        output: JSON_STRING
    }),
    countRoyaltyPeriodPayment: (royalty_period_id) => MHTTPCL.post(LABEL_URL, {
        action: "count_royalty_period_payment",
        section: 'royalty',
        royalty_period_id: royalty_period_id,
        output: JSON_STRING
    }),
    royaltyPeriodInvoiceInfo: (royalty_period_id) => MHTTPCL.post(LABEL_URL, {
        action: "royalty_period_invoice_info",
        section: 'royalty',
        royalty_period_id: royalty_period_id,
        output: JSON_STRING
    }),
    royaltyAccountExternalUserLinks: (royalty_account_id) => MHTTPCL.post(LABEL_URL, {
        action: "ra_external_user_links",
        section: 'royalty',
        royalty_account_id: royalty_account_id,
        output: JSON_STRING
    }),

}
